import React from "react";
import { ReactComponent as NotConfiguredIcon } from "../../../../assets/svg/fb-insights.svg";
import { ReactComponent as SettingsIcon } from "../../../../assets/svg/settings.svg";

const EmptyPage = ({ message, gptNoData }) => {
    return (
        <div className="empty__page__container">
            <NotConfiguredIcon className="empty__icon" />
            {gptNoData ? (
                <>
                    <p>
                        {gptNoData === "brand-comparision"
                            ? "You have not configured both the topics"
                            : ["overall-summary", "platform-summary"].includes(gptNoData)
                            ? "You have not configured your brand topic"
                            : "You have not configured any topic"}
                    </p>
                    <div className="lower__text">
                        <p>Please click on the</p>
                        <SettingsIcon className="gear__icon" />
                        <p> to configure</p>
                    </div>
                </>
            ) : (
                <p>{message ? message : "No data configured"}</p>
            )}
        </div>
    );
};

export default EmptyPage;
